import { render, staticRenderFns } from "./InstallBonus.vue?vue&type=template&id=1e1931b7&scoped=true&"
import script from "./InstallBonus.vue?vue&type=script&lang=js&"
export * from "./InstallBonus.vue?vue&type=script&lang=js&"
import style0 from "./InstallBonus.vue?vue&type=style&index=0&id=1e1931b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1931b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e1931b7')) {
      api.createRecord('1e1931b7', component.options)
    } else {
      api.reload('1e1931b7', component.options)
    }
    module.hot.accept("./InstallBonus.vue?vue&type=template&id=1e1931b7&scoped=true&", function () {
      api.rerender('1e1931b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/popup/InstallBonus.vue"
export default component.exports